// Script simple pour faire fonctionner les flèches sur mobile en mode vignettes latérales
document.addEventListener('DOMContentLoaded', function() {
    const mediaGallery = document.querySelector('[data-desktop-layout="thumbnail_side"]');
    if (!mediaGallery) return;
  
    const sliderComponent = mediaGallery.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!sliderComponent) return;
  
    const slider = sliderComponent.querySelector('[id^="Slider-Gallery-"]');
    const slides = slider.querySelectorAll('[id^="Slide-"]');
    const prevBtn = sliderComponent.querySelector('.slider-button--prev');
    const nextBtn = sliderComponent.querySelector('.slider-button--next');
    
    let currentSlide = 0;
    let isMobileMode = false;
  
    // Fonction pour vérifier si on est sur mobile
    function checkScreenSize() {
      const isMobile = window.innerWidth < 750;
      
      if (isMobile && !isMobileMode) {
        // Activer le mode mobile
        isMobileMode = true;
        initMobileSlider();
      } else if (!isMobile && isMobileMode) {
        // Désactiver le mode mobile et restaurer le comportement desktop
        isMobileMode = false;
        restoreDesktopSlider();
      }
    }
  
    function updateSlider() {
      if (!isMobileMode) return; // Ne rien faire si on n'est pas en mode mobile
      
      // Cacher toutes les slides
      slides.forEach((slide, index) => {
        if (index === currentSlide) {
          slide.classList.add('is-active');
          slide.style.display = 'block';
        } else {
          slide.classList.remove('is-active');
          slide.style.display = 'none';
        }
      });
  
      // Les boutons ne sont jamais disabled en mode loop infini
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
  
      // Mettre à jour le compteur s'il existe
      const counter = sliderComponent.querySelector('.slider-counter--current');
      if (counter) {
        counter.textContent = currentSlide + 1;
      }
    }
  
    function initMobileSlider() {
      // Trouver la slide active actuelle
      const activeSlide = slider.querySelector('.is-active[id^="Slide-"]');
      if (activeSlide) {
        const slideIndex = Array.from(slides).indexOf(activeSlide);
        if (slideIndex !== -1) {
          currentSlide = slideIndex;
        }
      }
      updateSlider();
    }
  
    function restoreDesktopSlider() {
      // Restaurer l'affichage normal des slides pour desktop
      slides.forEach(slide => {
        slide.style.display = '';
      });
      
      // Remettre les boutons dans leur état normal
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }
  
    // Event listeners pour les boutons avec loop infini (seulement sur mobile)
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        if (!isMobileMode) return; // Ne rien faire sur desktop
        
        e.preventDefault();
        if (currentSlide > 0) {
          currentSlide--;
        } else {
          // Si on est à la première image, aller à la dernière
          currentSlide = slides.length - 1;
        }
        updateSlider();
      });
    }
  
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        if (!isMobileMode) return; // Ne rien faire sur desktop
        
        e.preventDefault();
        if (currentSlide < slides.length - 1) {
          currentSlide++;
        } else {
          // Si on est à la dernière image, retourner à la première
          currentSlide = 0;
        }
        updateSlider();
      });
    }
  
    // Support tactile pour swipe sur mobile
    let startX = 0;
    let endX = 0;
  
    slider.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    });
  
    slider.addEventListener('touchend', function(e) {
      endX = e.changedTouches[0].clientX;
      handleSwipe();
    });
  
    function handleSwipe() {
      const diffX = startX - endX;
      const minSwipeDistance = 50;
  
      if (Math.abs(diffX) > minSwipeDistance) {
        if (diffX > 0) {
          // Swipe vers la gauche - slide suivante (avec loop)
          if (currentSlide < slides.length - 1) {
            currentSlide++;
          } else {
            currentSlide = 0; // Retourner à la première
          }
          updateSlider();
        } else if (diffX < 0) {
          // Swipe vers la droite - slide précédente (avec loop)
          if (currentSlide > 0) {
            currentSlide--;
          } else {
            currentSlide = slides.length - 1; // Aller à la dernière
          }
          updateSlider();
        }
      }
    }
  
    // Initialiser le mode en fonction de la taille d'écran
    checkScreenSize();
    
    // Écouter les changements de taille d'écran
    window.addEventListener('resize', checkScreenSize);
  }); 